/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import { ProfileService } from './ProfileService';

class ProfileServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ProfileService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { ProfileServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/ProfileServiceProvider.js